import { generatePath } from "react-router-dom";

import { PROJECT_DETAILS_PATH_WITH_TAB_ID } from "~/constants/appRoutes.ts";
import { ORDER_PARAM_NAME, ORDERSECTION_PARAM_NAME, SUBSECTION_PARAM_NAME } from "~/hooks/useSearchParamTab.ts";
import type { OrderDetailsTab } from "~/modules/project/components/ProjectDetailsView/components/Orders/ordersViewTypes.ts";
import type { ProjectBillingSubsection } from "~/modules/project/types/projectViewTypes.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";

export function getPhaseIdFromTabId(tabId: string): number {
	return parseInt(tabId.split("-")[1]);
}

export function isPhaseTabId(tabId: string): boolean {
	return tabId.startsWith(ProjectDetailsTabName.Phase);
}

export function generatePhaseTabId(phaseId: number): string {
	return ProjectDetailsTabName.Phase + phaseId;
}

export function getProjectBillingPath(projectId: string, subsection: ProjectBillingSubsection): string {
	const path = generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, { projectId, tabId: ProjectDetailsTabName.Billing });
	return `${path}?${SUBSECTION_PARAM_NAME}=${subsection}`;
}

export function getProjectReportsPath(projectId: string, subsection: string): string {
	const path = generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, { projectId, tabId: ProjectDetailsTabName.Reports });
	return `${path}?${SUBSECTION_PARAM_NAME}=${subsection}`;
}

export function getPhasePath(projectId: string, phaseNumber: number): string {
	return generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, {
		projectId,
		tabId: generatePhaseTabId(phaseNumber),
	});
}

export function getPhaseOrderPath(
	projectId: string,
	phaseNumber: number,
	orderId: string,
	orderSection?: OrderDetailsTab,
): string {
	const path = `${getPhasePath(projectId, phaseNumber)}?${ORDER_PARAM_NAME}=${orderId}`;
	return orderSection ? `${path}&${ORDERSECTION_PARAM_NAME}=${orderSection}` : path;
}